"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripStatus = void 0;
var TripStatus;
(function (TripStatus) {
    TripStatus["Draft"] = "Draft";
    TripStatus["Active"] = "Active";
    TripStatus["Inactive"] = "Inactive";
    TripStatus["Archive"] = "Archive";
})(TripStatus = exports.TripStatus || (exports.TripStatus = {}));
//# sourceMappingURL=Trip.js.map